<script context="module">
  import FundraiseUpElement from "$lib/contentTypes/FundraiseUpElement.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";

  const CTA_COMPONENT_MAP = {
    emailSignup: EmailSignupForm,
    fundraiseUpElement: FundraiseUpElement,
    linkComponent: LinkComponent
  };
</script>

<script>
  import CallToAction from "$lib/components/CallToAction.svelte";

  export let data;
  export let containerClass = "";
  export let bodyClass = "";
  export let titleClass = "";
  export let descriptionClass = "";

  const { fields } = data;
</script>

<div class="embedded-content" data-self-spaced={fields.backgroundColor}>
  <CallToAction
    {...fields}
    {containerClass}
    {bodyClass}
    {titleClass}
    {descriptionClass}
    title={fields.action?.fields?.title || fields.title}
    description={fields.action?.fields?.description || fields.description}
    actions={fields.action ? [fields.action] : fields.actions}
    componentMap={CTA_COMPONENT_MAP}
  />
</div>
